import { render, staticRenderFns } from "./ProjectPlatformAmazonAlexa.vue?vue&type=template&id=752f1c06"
import script from "./ProjectPlatformAmazonAlexa.vue?vue&type=script&lang=ts"
export * from "./ProjectPlatformAmazonAlexa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports